import { BrowserRouter, Routes, Route, useParams, Navigate } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import Home from './pages/home/Home'
import Admin from './pages/admin/Admin'
import MyBookings from './pages/myBookings/MyBookings'
import CheckIn from "./pages/checkin/CheckIn"
import WaiverPage from "./pages/waiver/WaiverPage"
import WaitlistOffer from "./pages/waitlist/WaitlistOffer"
import NotFound from './pages/notFound/NotFound'
import studios from './studios'
import { StudioContext } from './studios/StudioContext'
import Videos from './pages/videos/Videos'
import DemoBanner from './components/DemoBanner'
import StudioNav from './components/StudioNav'

// demo.florium.live serves only the demo studio; other hosts don't serve it (except local dev).
const HOST = typeof window !== 'undefined' ? window.location.hostname : ''
const DEMO_HOST = HOST.startsWith('demo.')
const LOCAL_HOST = ['localhost', '127.0.0.1'].includes(HOST)

function Layout() {
  const { studioId } = useParams();
  const config = studios[studioId];
  const themeRef = useRef(null);

  useEffect(() => {
    if (config?.theme && themeRef.current) {
      Object.entries(config.theme).forEach(([prop, value]) => {
        themeRef.current.style.setProperty(prop, value);
        document.documentElement.style.setProperty(prop, value); // page background etc. follow the studio too
      });
    }
  }, [config]);

  useEffect(() => {
    if (config?.studioName) document.title = `${config.studioName} | Book`;
  }, [config]);

  if (DEMO_HOST && studioId !== 'demo') return <Navigate to="/demo" replace />;
  if (!DEMO_HOST && !LOCAL_HOST && studioId === 'demo') return <NotFound />;
  if (!config) return <NotFound />;

  return (
    <div ref={themeRef} className="studio-theme-root">
      <StudioContext.Provider value={config}>
        {config.flags?.demoBanner && <DemoBanner />}
        {config.flags?.siteNav && <StudioNav />}
        <Routes>
          <Route index element={<Home />} />
          <Route path="admin" element={<Admin />} />
          <Route path="my-bookings" element={<MyBookings />} />
          <Route path="checkin" element={<CheckIn />} />
          <Route path="waiver" element={<WaiverPage />} />
          <Route path="waitlist" element={<WaitlistOffer />} />
          <Route path="videos" element={<Videos />} />
          <Route path="videos/:videoId" element={<Videos />} />
          <Route path="videos/embed" element={<Videos embedOnly={true} />} />
          <Route path="embed" element={<Home embedOnly={true} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </StudioContext.Provider>
    </div>
  );
}

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to={DEMO_HOST ? "/demo" : "/iy-sp"} replace />} />
      <Route path="/:studioId/*" element={<Layout />} />
    </Routes>
  </BrowserRouter>
);

export default App;
